/**
 *  Google Analytics 4
 * -------------------------------------------------------------------------- */
const events = require('./events');

function init() {
  events.init();
}

module.exports = {
  init,
};
